export default {
	transparent: "#00000000",
	black: "#000",
	red: "#f00",
	blue: "#0f00ff",
	yellow: "#fbff00",
	green: "#1cff00"

}